export const REDUX_FIELD_NAME = 'fields';

export const SIMPLE_REDUX_FIELDS__OPEN = 'SIMPLE_REDUX_FIELDS__OPEN';
export const SIMPLE_REDUX_FIELDS__CLOSE = 'SIMPLE_REDUX_FIELDS__CLOSE';
export const SIMPLE_REDUX_FIELDS__SET = 'SIMPLE_REDUX_FIELDS__SET';
